<div class="row sticky dialog-title-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
  <div class="col-12 unset-p">
    <div class="flex relative align-centre dialog-title">
      <ng-template [ngIf]="icon">
        <span class="textGreen font16 b-radius dialog-title-icon"
          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
          <fa-icon [icon]="icon"></fa-icon>
        </span>
      </ng-template>
      <span class="font17" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{title}}</span>
      <div class="absolute" style="right: 15px;">
        <span class="textGreen font16 b-radius dialog-title-icon cursorPointer" (click)="close()"
          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
          <fa-icon [icon]="faXmark"></fa-icon>
        </span>
      </div>
    </div>
  </div>
</div>